import { TAX_CATEGORIES, type TaxCategory } from '@his/shared';
import { ChoiceButtons } from './ui/choice-buttons';
import { Field } from './ui/primitives';

export const TAX_CATEGORY_LABEL: Record<TaxCategory, string> = {
  standard: 'Standard rated',
  zero: 'Zero rated',
  exempt: 'Exempt',
  out_of_scope: 'Outside the scope of tax',
};

export function TaxCategorySelect({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <Field label="Tax category" hint="Blank uses the country default for this kind of item">
      <ChoiceButtons
        layout="chips"
        value={value}
        onChange={onChange}
        options={[
          { value: '', label: 'Country default' },
          ...TAX_CATEGORIES.map((category) => ({ value: category, label: TAX_CATEGORY_LABEL[category] })),
        ]}
      />
    </Field>
  );
}
